/* eslint-disable */
import { CountUp } from 'countup.js';

const initCountUp = () => {
  const items = Array.from(document.querySelectorAll('.js-count-up'));
  const activeClass = 'in-viewport';

  if (!items.length) return;

  items.map((item) => {
    const target = item.getAttribute('data-target') || item.getAttribute('data-start');
    const duration = item.getAttribute('data-duration') ? parseInt(item.getAttribute('data-duration')) / 1000 : 2;
    const parent = item.closest('.case-statistic') || item.closest('.stats-counter-item');

    var numAnim = new CountUp(item, target, {
      duration: duration,
      separator: ',',
      decimal: '.',
    });

    let observer = new IntersectionObserver(function (entries, observer) {
      if (entries[0].isIntersecting === true) {
        numAnim.start();
        if (parent) {
          parent.classList.add(activeClass);
        }
      }
    });

    observer.observe(item);
  });
};

export default initCountUp;
